import React, { createContext, useContext } from 'react';

// undefined means "not provided" — Seo falls back to window.location on the client.
const CanonicalUrlContext = createContext<string | undefined>(undefined);

export interface CanonicalUrlProviderProps {
  canonicalUrl: string | undefined;
  children: React.ReactNode;
}

// Must live inside HelmetProvider but outside the routing layer.
export function CanonicalUrlProvider({
  canonicalUrl,
  children,
}: CanonicalUrlProviderProps): React.ReactElement {
  return (
    <CanonicalUrlContext.Provider value={canonicalUrl}>{children}</CanonicalUrlContext.Provider>
  );
}

// Returns undefined when provider is absent or server passed undefined.
export function useCanonicalUrl(): string | undefined {
  return useContext(CanonicalUrlContext);
}
